import * as React from "react";
import type { SVGProps } from "react";
const SvgChildrenPlaySpace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12.29 1.04 10 3c.53.16.83.72.67 1.25a1.005 1.005 0 0 1-1.25.67L12 3.05 2.29 5.96a1.003 1.003 0 0 1-.58-1.92l10.01-3c.18-.06.38-.06.57 0m4.91 5.97c.38-.05.74.18.92.51l.02-.02 1.94 3.5c.21.39.15.87-.17 1.19l-1.17 1.17a.99.99 0 0 1-1.15.19l-.66-.33-.17.34 1.15 4.88c.42-.26.97-.19 1.29.2a1 1 0 0 1-.14 1.41c-2.41 1.98-4.83 2.97-7.25 2.97s-4.85-.99-7.25-2.97a1 1 0 0 1-.14-1.41c.31-.38.84-.45 1.26-.21l.98-4.66c-.5.2-.86.69-.86 1.24s-.45 1-1 1-1-.45-1-1c0-1.83 1.49-3.33 3.33-3.33h3.96c.77-2.12 1.94-4.49 6.11-4.67m-6.28 11.33-.96 2.41c1.23.32 2.45.32 3.68 0l-.96-2.41zm6.903-6.883L16.92 11a.96.96 0 0 0-.76-.05c-.25.08-.46.26-.58.5l-.78 1.56c-.1.21-.13.45-.08.68l1.41 6-.167.096q-.225.132-.453.254l-1.23-3.06a1 1 0 0 0-.93-.63h-3.11a1 1 0 0 0-.93.63l-1.23 3.06q-.315-.165-.63-.36l1.26-6h3.08c.42 0 .8-.27.94-.67l.04-.11c.71-2.03 1.24-3.53 3.9-3.84l1.27 2.28z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChildrenPlaySpace;
